import { FunctionComponent, useEffect, useCallback } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { FullScreenLoader } from '@Components/index';
import { RoutesConstants } from '@Constants/index';
import { SMTPSettingsVerificationProps } from '@Containers/Emails/SMTPSettingsVerification/SMTPSettings.types';
import { useVerifySMTPSettingsMutation } from '@Services/smtpSettings.service';
import useAlert from '@Utils/hooks/useAlert.hook';

const SMTPSettingsVerification: FunctionComponent<SMTPSettingsVerificationProps> =
  (props: SMTPSettingsVerificationProps): JSX.Element => {
    const { token } = useParams<{ token: string }>();
    const history = useHistory();
    const { triggerAlert } = useAlert();
    const { setAlertState } = props;

    const [verifySMTPSettings, verifySMTPSettingsMethods] =
      useVerifySMTPSettingsMutation();

    const { isLoading, isSuccess, isError } = verifySMTPSettingsMethods;

    const handleVerify = useCallback(
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      (): void => verifySMTPSettings({ token }),
      [token, verifySMTPSettings]
    );

    useEffect(() => {
      handleVerify();
    }, [handleVerify]);

    useEffect(() => {
      if (isSuccess) {
        history.push(RoutesConstants.EMAILS_ROUTES.SMTP);
      }
    }, [history, isSuccess]);

    useEffect(() => {
      if (isError && setAlertState) {
        const { error } = verifySMTPSettingsMethods;
        if ('data' in error) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          triggerAlert(error.data.message, setAlertState, 'error');

          setTimeout(() => {
            history.push(RoutesConstants.EMAILS_ROUTES.SMTP);
          }, 3000);
        }
      }
    }, [
      history,
      isError,
      setAlertState,
      triggerAlert,
      verifySMTPSettingsMethods,
    ]);

    return isLoading ? <FullScreenLoader /> : <div />;
  };

export default SMTPSettingsVerification;
